import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageGex: React.FC = () => (
  <LocalSeoPage
    city="Gex"
    slug="depannage-informatique-gex"
    metaTitle="Dépannage Informatique Gex | Technicien PC Pays de Gex"
    metaDescription="Dépannage informatique à Gex et dans le Pays de Gex. Réparation PC, Mac, tablettes. Intervention rapide. Diagnostic gratuit."
    intro="Vous habitez à Gex ou dans le Pays de Gex et votre ordinateur vous pose problème ? Nous intervenons rapidement dans tout le secteur : PC lent, virus, panne réseau, Windows bloqué. À domicile ou à distance, on s'occupe de tout. Diagnostic gratuit et devis sans engagement."
    postalCode="01170"
    nearbyTowns={[
      { name: 'Ferney-Voltaire', link: '/depannage-informatique-ferney-voltaire' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Prévessin-Moëns', link: '/depannage-informatique-prevessin-moens' },
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Cessy', link: '/depannage-informatique-cessy' },
      { name: 'Ornex', link: '/depannage-informatique-ornex' },
      { name: 'Segny', link: '/depannage-informatique-segny' },
      { name: 'Thoiry' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Ferney-Voltaire', href: '/depannage-informatique-ferney-voltaire' },
      { label: 'Dépannage informatique à Saint-Genis-Pouilly', href: '/depannage-informatique-saint-genis-pouilly' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique à Prévessin-Moëns', href: '/depannage-informatique-prevessin-moens' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Cessy', href: '/depannage-informatique-cessy' },
      { label: 'Dépannage informatique à Ornex', href: '/depannage-informatique-ornex' },
      { label: 'Dépannage informatique à Segny', href: '/depannage-informatique-segny' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageGex;
